import React, { useEffect, useState } from 'react';
import LoadingIcon from '../../../../LoadingIcon';
import TpInstanceService from '../../../../../Services/TpInstanceService.js';
import MultiChoice from './MultiChoice';
import ErrorMessage from '../../../../ErrorMessage';

const PLATFORM_ORDER = ['Apollo', 'Prism', 'PrismIntl', 'RMX'];

export default function PlatformMultiChoice({ selected = [], onChange = () => {} }) {
  const [loading, setLoading] = useState(true);
  const [itemList, setItemList] = useState([]);

  useEffect(() => {
    TpInstanceService.GetThirdPartyInstanceList()
      .then((result) => {
        const families = [];
        (result || []).forEach((source) => {
          const name = source.thirdPartySourceName;
          const family = name && name.indexOf('RMX') === 0 ? 'RMX' : name;
          if (family && families.indexOf(family) === -1) {
            families.push(family);
          }
        });
        families.sort((a, b) => {
          const ia = PLATFORM_ORDER.indexOf(a);
          const ib = PLATFORM_ORDER.indexOf(b);
          return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
        });
        setItemList(families.map((f) => ({ label: f, value: f })));
        setLoading(false);
      })
      .catch((error) => ErrorMessage.SetErrorMessage('PLMC01', error));
  }, []);

  return (
    <div className='w-100 text-center hover rounded arial'>
      {loading ? (
        <LoadingIcon
          loading={true}
          className='h6'
        />
      ) : (
        <MultiChoice
          label=''
          className='rmsc'
          options={itemList}
          selected={selected}
          onChange={onChange}
          labelledBy='Select'
        />
      )}
    </div>
  );
}
